
import MenuGemeralLeft from './MenuGemeralLeft';
const GeneralSettingMain = ({menuItems, storeTitleMenus, setStoreTitleMenus}) => {
  return (
    <>
      <MenuGemeralLeft menuItems={menuItems} storeTitleMenus={storeTitleMenus} setStoreTitleMenus={setStoreTitleMenus}/>
    </>
  );
};
export default GeneralSettingMain;